import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const { user, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-lg fixed top-0 left-0 w-full z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16 items-center">
          {/* Logo Section */}
          <div className="flex items-center">
            <img
              src="/create-your-valentine-logo.png"
              alt="Create Your Valentine Logo"
              className="h-8 mr-2"
            />
            <Link to="/" className="text-xl font-bold text-pink-600">
              Create Your Valentine 2
            </Link>
          </div>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center space-x-6">
            {user ? (
              <>
                <Link
                  to="/create"
                  className="text-gray-700 hover:text-pink-600"
                >
                  Create Valentine
                </Link>
                <Link
                  to="/my-valentines"
                  className="text-gray-700 hover:text-pink-600"
                >
                  My Valentines
                </Link>
                <button
                  onClick={() => signOut()}
                  className="text-gray-700 hover:text-pink-600"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-gray-700 hover:text-pink-600">
                  Sign In
                </Link>
                <Link
                  to="/register"
                  className="text-gray-700 hover:text-pink-600"
                >
                  Register
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 ${
          menuOpen ? 'block' : 'hidden'
        } bg-white shadow-md`}
      >
        <div className="px-4 py-4 space-y-2">
          {user ? (
            <>
              <Link
                to="/create"
                className="block text-gray-700 hover:text-pink-600"
                onClick={() => setMenuOpen(false)}
              >
                Create Valentine
              </Link>
              <Link
                to="/my-valentines"
                className="block text-gray-700 hover:text-pink-600"
                onClick={() => setMenuOpen(false)}
              >
                My Valentines
              </Link>
              <button
                onClick={() => {
                  signOut();
                  setMenuOpen(false);
                }}
                className="block text-gray-700 hover:text-pink-600 w-full text-left"
              >
                Sign Out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="block text-gray-700 hover:text-pink-600"
                onClick={() => setMenuOpen(false)}
              >
                Sign In
              </Link>
              <Link
                to="/register"
                className="block text-gray-700 hover:text-pink-600"
                onClick={() => setMenuOpen(false)}
              >
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
